// extracted by mini-css-extract-plugin
module.exports = {"status":"WebhookDetails_status__3YrVg","green":"WebhookDetails_green__6py_d"};